import { createContext, useContext } from 'react';

import type App from './App';

export const AppContext: React.Context<App> = createContext<App>(undefined!);

AppContext.displayName = 'AppContext';

export function useApp<T extends App>(): T {
    return useContext(AppContext) as T;
}